import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React from 'react'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import ResponsiveImage from 'components/images/responsive-image'
import Typo from 'constants/typography'
import Accordion from 'components/common/accordion'
import { renderStoreAndMapImages } from './utils'
import StoreInformation from './store-information'
import styles from './style.scss'

const PickUpAccordion = ({ addressess, internationalization }) => {
  const renderBodyArea = (address) => {
    if (internationalization.shop === 2) {
      return (
        <div className="pick-up-accordion-container" key={address.alias}>
          <div className="pick-up-accordion__content-wrapper">
            <ResponsiveImage
              src={renderStoreAndMapImages(address, 'mainImage')}
              alt="Meet Pomelo"
              imgRatio={0.625}
            />
            <span className="PUAC__title_text">
              {address?.alias && (
                <span>
                  {address.alias?.length <= 24
                    ? address.alias
                    : `${address.alias.substr(0, 24)}...`}
                </span>
              )}
            </span>
          </div>
          <StoreInformation address={address} />
        </div>
      )
    }

    return (
      <div key={address?.id_pickup_location} className="PUAC__store">
        <ResponsiveImage
          src={renderStoreAndMapImages(address, 'mainImage')}
          alt="Meet Pomelo"
          imgRatio={0.625}
        />
        <Accordion
          title={
            address?.alias && (
              <span className={clsx(Typo.h6, 'PUAC__accordion-title')}>
                {address.alias}
              </span>
            )
          }
          withArrow
        >
          <StoreInformation address={address} />
        </Accordion>
      </div>
    )
  }

  if (addressess?.length > 0) {
    return (
      <div className="pick-up-accordion-container">
        <style jsx>{styles}</style>
        {addressess.map((address) => renderBodyArea(address))}
      </div>
    )
  }

  return null
}

PickUpAccordion.propTypes = {
  addressess: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  internationalization: PropTypes.shape({
    shop: PropTypes.number,
  }).isRequired,
}

const Extended = withI18next()(PickUpAccordion)

export default connect((state) => ({
  internationalization: state.internationalization,
}))(Extended)
